import React, { useEffect, useState } from "react";
import FormRender from "../../components/FormRender";
import { PRODUCT_VIDEO_FORM_SETTING, PRODUCT_VIDEO_FORM_SETTING_META } from "../../helper";
import { useSearchParams } from "react-router-dom";
import useAxiosInstance from "../../hooks/useAxios";
import { toast } from "react-toastify";


const EditProductVideo = () => {
    const axiosInstance = useAxiosInstance();
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({
        title: "",
        description: "",
        thumbnail_img: "",
        video_src: "",
        type: "features_videos",
        is_sidebar_video: false,
        meta: {
            time: "",
            order: "",
            feature_type: "",
            home: false,
            report_type: "",
            email_video_desc: "",
            feature_card_key: "",
        }
    });
    const [saving, setSaving] = useState(false);
    const [searchParams] = useSearchParams();

    const setMetaFormData = (metaUpdate) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            meta: {
                ...prevFormData.meta,
                ...metaUpdate,
            },
        }));
    };

    useEffect(() => {
    setLoading(true);
    const videoId = searchParams.get('product_video_id');
    if (!videoId) {
        toast.error("No video ID provided.");
        setLoading(false);
        return;
    }

    axiosInstance.get(`/assets/get_a_product_video/?product_video_id=${videoId}`)
        .then((res) => {
            const fetchedData = res.data;
            setFormData(fetchedData);
            setLoading(false);
        })
        .catch(err => {
            toast.error("Failed to fetch video details.");
            setLoading(false);
        });
    setLoading(false);
    }, [searchParams]);


    function handleSave() {
        setSaving(true);
        const videoId = searchParams.get('product_video_id')
        const payload = {
            ...formData,
            is_sidebar_video: Boolean(formData.is_sidebar_video),
            meta: formData.meta,
            product_video_pk:videoId
        };
            const _formData = new FormData();
        _formData.append('payload', JSON.stringify(payload));
        _formData.append('thumbnail_img', payload.thumbnail_img);
        
        axiosInstance.post('/assets/edit_a_product_video/', _formData, {
            headers: {
            'Content-Type': 'multipart/form-data',
            },
        }).then(res=>{
            if(res.status===200){
                toast.success('Successfully edited!')
            }else{
                toast.error('Failed!')
            }
            setSaving(false);
        }).catch(err=>{
            toast.error('Failed!');
            setSaving(false);})
        console.log("This payload", payload);
    }

    return (
        <div>
            <div className="p-6">
                <div className="text-2xl font-semibold items-center flex justify-between">
                    Edit Product Video
                </div>
                <div className="mt-4 p-4 border rounded-lg bg-white  flex flex-col gap-y-4">
                    {loading ? (
                        'loading....'
                    ) : (
                        <>
                            <FormRender
                                formData={formData}
                                formSettings={[...PRODUCT_VIDEO_FORM_SETTING.filter(it => it.saveKey !== 'type'), {
                                    label: "Product Video Type*",
                                    type: "select",
                                    saveKey: "type",
                                    readonly: true,
                                    options: PRODUCT_VIDEO_FORM_SETTING.find(it => it.saveKey === 'type')?.options
                                }]}
                                // formSettings={PRODUCT_VIDEO_FORM_SETTING}
                                setFormData={setFormData}
                            />

                            <div className="text-2xl font-semibold items-center flex justify-between">
                                Meta
                            </div>

                            <FormRender
                                formData={formData.meta}
                                formSettings={PRODUCT_VIDEO_FORM_SETTING_META}
                                setFormData={setMetaFormData}
                            />
                        </>
                    )}
                    <button
                        onClick={handleSave}
                        disabled={loading || saving}
                        className="text-sm px-3 py-2 self-end bg-black rounded-lg text-white disabled:bg-slate-400"
                    >
                        {saving ? "Saving..." : "Save"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EditProductVideo;